<script lang="ts">
  import { Button } from "$lib/components/ui/button/index.js";
  import * as Tooltip from "$lib/components/ui/tooltip/index.js";
  import { Info } from "lucide-svelte";
  import * as Alert from "$lib/components/ui/alert/index.js";
  import { t } from "svelte-i18n";

  export let countryCode: string;
</script>

    <Tooltip.Root>
      <Tooltip.Trigger asChild let:builder>
        <Button builders={[builder]} variant="link" class="p-0 font-normal italic text-muted-foreground">
          <Info class="mr-1 h-4 w-4" />
          <a
            target="_blank"
            class="text-xs"
            href={$t("page.projects.detail.houseRules.info-url." + countryCode)}
          >
            {$t("page.projects.detail.houseRules.title")}
          </a>
        </Button>
      </Tooltip.Trigger>
      <Tooltip.Content class="max-w-xs">
        {$t("page.projects.detail.houseRules.rule." + countryCode)}
      </Tooltip.Content>
    </Tooltip.Root>
